import React from 'react';

export default function DashboardShell({
    title,
    subtitle,
    right,
    children,
}: {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    right?: React.ReactNode;
    children: React.ReactNode;
}) {
    return (
        <div className="min-h-full w-full bg-[radial-gradient(circle_at_top_left,_rgba(14,165,233,0.08),_transparent_28%),linear-gradient(180deg,#f8fbff_0%,#f4f7fb_100%)] px-4 py-5 md:px-6 lg:px-8">
            <div className="rounded-[28px] border border-slate-200/80 bg-white/88 p-5 shadow-[0_20px_55px_-28px_rgba(15,23,42,0.28)] backdrop-blur md:p-6">
                <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
                    <div className="min-w-0">
                        <div className="text-[11px] font-medium uppercase tracking-[0.18em] text-slate-500">Project Dashboard</div>
                        <div className="mt-2 text-2xl font-semibold tracking-tight text-slate-950 md:text-[30px]">{title}</div>
                        {subtitle && <div className="mt-2 text-sm text-slate-500">{subtitle}</div>}
                    </div>
                    {right && <div className="flex shrink-0 items-center gap-2">{right}</div>}
                </div>

                <div className="mt-6">{children}</div>
            </div>
        </div>
    );
}
